export default __webpack_public_path__ + "static/agnes-ee42c102a2ed8d3805987f35099b3eaf.jpg";